import { createContext, Dispatch, ReactNode, SetStateAction } from 'react'

export type SidebarContext = {
  isOpen: boolean,
  toggleOpen: () => void,
}

export const SidebarContext = createContext<SidebarContext>({
  isOpen: true,
  toggleOpen: () => {},
})

export type SidebarProviderProps = {
  value: boolean,
  setOpen: Dispatch<SetStateAction<boolean>>,
  children: ReactNode
}

export function SidebarProvider({ children, value, setOpen }: SidebarProviderProps) {
  const context = {
    isOpen: value,
    toggleOpen: () => setOpen(prev => !prev),
  }

  return (
    <SidebarContext.Provider value={context}>
      { children }
    </SidebarContext.Provider>
  )
}
